
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/core/services/ApiService";
import UploadApplicationFileModal from "@/components/modals/general/UploadApplicationFileModal.vue";
import { Modal } from "bootstrap";
import PdfViewModal from "@/components/modals/general/PdfViewModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  components: { UploadApplicationFileModal, PdfViewModal },
  setup() {
    const isAddedFile = ref(false);
    const route = useRoute();
    const loading = ref(false);
    const applicationFiles = ref([]);
    const applicationFilesTotal = ref(0);
    const getAppId = computed(() => {
      return route.params.id;
    });
    onMounted(async () => {
      setTimeout(() => {
        getApplicationFiles();
      }, 500);
    });
    const getApplicationFiles = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `img/ibo_files?app_id=${getAppId.value}`
      );
      applicationFiles.value = res2.data.data;
      applicationFilesTotal.value = res2.data.meta.total;

      loading.value = false;
    };

    const pdfUrl = ref("");
    const onOpenPdfView = (url) => {
      pdfUrl.value = url;
      const modal = new Modal(document.getElementById("modal_pdf_view"));
      modal.show();
    };
    const fileDeleteLoading = ref(false);
    const onDeleteFile = async (index) => {
      fileDeleteLoading.value = true;
      try {
        const res = await ApiService.delete(`img/ibo_files/${index}`);
        if (res.data.success) {
          Swal.fire({
            text: "File Deleted!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationFiles();
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      fileDeleteLoading.value = false;
    };
    return {
      isAddedFile,
      applicationFiles,
      applicationFilesTotal,
      getAppId,
      onOpenPdfView,
      getApplicationFiles,
      onDeleteFile,
      fileDeleteLoading,
      pdfUrl,
    };
  },
});
